<section class="initiatives-overview section-inset-b">
  <ng-container *ngIf="initiatives$ | async as initiatives">
    <header class="mb-0 mt-7 overview__header">
      <div class="container overview__header__inner">
        <div class="overview__header__content">
          <span class="fw-bold font-secondary text-secondary">
            {{ 'initiatief-overzicht-subtitel' | fromDictionary }}
          </span>
          <h1 class="text-primary">
            {{ 'initiatief-overzicht-titel' | fromDictionary }}
            <app-icon anchor="icon-squiggle" class="heading-squiggle"></app-icon>
          </h1>

          <app-theme-filters
            class="d-block mt-4 mb-md-n3"
            *ngIf="(themes$ | async)?.length"
            [themes]="(themes$ | async)!"
            [loading]="filtersLoading"
            [activeTheme]="theme"
            #filterEl
          ></app-theme-filters>
        </div>

        <form class="overview__header__action order-by" [formGroup]="sortForm">
          <mat-form-field appearance="fill" class="select-lg">
            <mat-label>{{ 'initiatief-overzicht-sorteer-titel' | fromDictionary }}</mat-label>
            <mat-select formControlName="orderBy" disableOptionCentering panelClass="select-lg__panel">
              <mat-option *ngFor="let sortItem of sortOptions" [value]="sortItem.value">
                {{ sortItem.placeholder | fromDictionary }}
              </mat-option>
            </mat-select>
            <app-icon
              class="icon-primary"
              *ngIf="sortLoaded || (geoLocationError$ | async)"
              anchor="icon-chevron-down"
              matSuffix
            ></app-icon>
            <app-icon
              class="icon-primary animate--rotate"
              *ngIf="!sortLoaded && (geoLocationError$ | async) === undefined"
              anchor="icon-loading"
              matSuffix
            ></app-icon>
          </mat-form-field>
        </form>

        <div class="w-100" *ngIf="geoLocationError$ | async as error">
          <app-alert
            class="d-block"
            [message]="geoErrorLabel[error?.code || 4].placeholder | fromDictionary"
            [status]="'warning'"
            [title]="'geolocatie-error-titel' | fromDictionary"
          ></app-alert>
        </div>
      </div>
    </header>

    <app-bg-wave class="initiatives-overview__wave type--top"></app-bg-wave>

    <main class="bg-secondary section-inset-b pt-4">
      <div class="container">
        <!--<pre *ngIf="(initiativesLoading$ | async) === true">TODO use this for skeleton loading</pre>-->

        <ul class="row" [@CardGridAnimation]="initiatives?.length">
          <li class="text-center mb-2" *ngIf="initiativesLoading$ | async">
            <mat-spinner
              aria-label="Initiativen laden..."
              class="ms-3 d-inline-block"
              [diameter]="20"
              [value]="20"
              [color]="'accent'"
            ></mat-spinner>
          </li>

          <ng-container *ngFor="let initiative of initiatives; let i = index; trackBy: trackByFn">
            <li class="col-12 col-sm-6 col-md-6 col-lg-4 mb-3 mb-sm-4">
              <app-initiative-card [initiative]="initiative" [location]="geoLocation$ | async"></app-initiative-card>
            </li>
            <li *ngIf="i === 5" class="col-12 mb-3 mb-sm-4 py-sm-5">
              <app-call2-action-initiative></app-call2-action-initiative>
            </li>
          </ng-container>

          <li class="overview-empty-state" *ngIf="!initiatives.length">
            <p>{{ 'overzicht-empty-state' | fromDictionary }}</p>

            <a class="button button--primary rounded-pill" [routerLink]="['.']" [queryParams]="{}">
              {{ 'reset-filters-knop-tekst' | fromDictionary }}
            </a>
          </li>
        </ul>
        <ng-container *ngIf="page$ | async as page">
          <footer class="mt-5 text-center">
            <button
              class="button button--primary"
              (fstrInViewport)="loadMore()"
              [once]="false"
              *ngIf="page.resultCount > initiatives.length"
              (click)="loadMore()"
            >
              {{ 'initiatief-overzicht-meerladen-label' | fromDictionary }}
              <mat-spinner
                aria-label="Bezig met meer iniatieven laden..."
                class="ms-3"
                [diameter]="20"
                [value]="20"
                [color]="'accent'"
                aria-label="Bezig met laden"
              ></mat-spinner>
            </button>
          </footer>
        </ng-container>
      </div>
    </main>
    <app-bg-wave class="initiatives-overview__wave type--end"></app-bg-wave>

    <ng-container *ngIf="page$ | async as page">
      <div
        class="container section-inset-y mb-0 mb-md-6"
        *ngIf="
          (page.resultCount <= initiatives.length && initiatives.length > 12) ||
          (page.resultCount <= initiatives.length && initiatives.length < 6)
        "
      >
        <app-call2-action-initiative></app-call2-action-initiative>
      </div>
    </ng-container>
  </ng-container>
</section>
